import React from 'react';
import { Button, IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import { Close } from '@mui/icons-material';
import useBannerList from '../../hooks/useBannerList';
import MfAlert from '../UI/Alert/MfAlert';
import useBannerState from './useBannerState';

const TopBanner = () => {
  const [data] = useBannerList();
  const [bannersViewedState, setViewed, processing] = useBannerState();

  if (!Array.isArray(data) || data.length === 0 || processing) {
    return null;
  }

  const dataToRender = data.filter((v) => !bannersViewedState.includes(v.id));

  return (
    <div>
      {dataToRender.map((v) => (
        <MfAlert
          key={v.id}
          sx={{ mb: 1 }}
          variant="standard"
          severity="info"
          action={
            <Box sx={{ textAlign: 'right', pb: 1 }}>
              <IconButton
                size="small"
                onClick={() => setViewed(v.id)}
                disabled={processing}
              >
                <Close fontSize="small" />
              </IconButton>
              {v.actionLabel && (
                <Box sx={{ display: 'flex' }}>
                  <Button
                    sx={{ mt: 2, mr: 1 }}
                    variant="contained"
                    size="medium"
                    target="_blank"
                    href={v.actionUrl}
                  >
                    {v.actionLabel}
                  </Button>
                </Box>
              )}
            </Box>
          }
        >
          <Box>
            <div dangerouslySetInnerHTML={{ __html: v.body }} />
          </Box>
        </MfAlert>
      ))}
    </div>
  );
};

export default TopBanner;
